import * as React from 'react'
import * as Menu from '../../components/menu'

export const routes = [
  {
    action: () => <span/>,
    path: Menu.AUTH_LOGIN_VALIDATION_URL,
  },
]



// WEBPACK FOOTER //
// ./src/pages/login/routes.tsx